import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { VendorPayoffsPage } from './VendorPayoffsPage';
import { getVendorPayoffsData } from 'store/vendorStore/vendorPayoffs/dispatch';
import { eTitleSearchStatus } from '../../../types/order/title/eTitleSearchStatus';
import { VendorSelectors } from '../../../selectors/vendorPortal/VendorSelectors';
import { VendorWrapper } from '../../../components/vendorDashboard/VendorWrapper';
import { useAppDispatch } from '../../../store/store';

interface IVendorPayoffsContainerProps {}

export const VendorPayoffsContainer: React.FC<IVendorPayoffsContainerProps> = () => {
  const dispatch = useAppDispatch();
  const [updateInformation, setUpdateInformation] = useState(false);
  const { payoffs, searchSettings, payoffsError, payoffsFetchStatus } = useSelector(VendorSelectors.selectPayoffs);

  useEffect(() => {
    if (!updateInformation) {
      // update info if user return from another page
      setUpdateInformation(true);
      dispatch(
        getVendorPayoffsData(
          searchSettings.statuses,
          searchSettings.pageSize,
          searchSettings.page,
          searchSettings.fileNumber
        )
      );
    }
  }, [dispatch, searchSettings, updateInformation]);

  const onFilterOrder = (status: eTitleSearchStatus[]) => {
    dispatch(getVendorPayoffsData(status, searchSettings.pageSize, searchSettings.page));
  };

  const onPageSizeUpdate = (pageSize: number) => {
    dispatch(getVendorPayoffsData(searchSettings.statuses, pageSize, searchSettings.page));
  };

  const onPageUpdate = (page: number) => {
    dispatch(getVendorPayoffsData(searchSettings.statuses, searchSettings.pageSize, page));
  };

  const onSearchPayoff = (value: any) => {
    dispatch(
      getVendorPayoffsData(
        searchSettings.statuses,
        searchSettings.pageSize,
        searchSettings.page,
        value.fileNumber || undefined
      )
    );
  };
  return (
    <VendorWrapper isLoading={payoffsFetchStatus.fetching}>
      <VendorPayoffsPage
        pageError={payoffsError}
        payoffs={payoffs}
        searchSettings={searchSettings}
        loadingPayoffs={payoffsFetchStatus.fetching}
        onFilterPayoff={onFilterOrder}
        onPageSizeUpdate={onPageSizeUpdate}
        onPageUpdate={onPageUpdate}
        onSearchPayoff={onSearchPayoff}
      />
    </VendorWrapper>
  );
};
